import React from 'react';
import { ShipmentInfoReturnListTemplate } from 'themes/modules/shipment-info-return/pages';
import { ShipmentInfoReturnListViewStore } from 'modules/shipment-info-return/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView(rootStore => new ShipmentInfoReturnListViewStore(rootStore), 'shipmentInfoReturnListViewStore')
class ShipmentInfoReturnList extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return <ShipmentInfoReturnListTemplate {...this.props} viewStore={this.props.shipmentInfoReturnListViewStore} />;
	}
}

export default ShipmentInfoReturnList;
